import React from "react";
import { Close } from "@material-ui/icons";
import { cleanText } from "../../utils/clean-possible-resolutions-text.util";

const ErrorAlert = (props) => {
  const {
    description,
    possibleResolutions,
    index,
    handleCloseErrors,
    followupAction,
  } = props;
  return (
    <div
      style={{
        border: "1px solid hsl(0deg 84.2% 60.2% / 50%)",
        borderRadius: "0.5rem",
        color: "hsl(0 84.2% 60.2%)",
        padding: "1rem",
        marginTop: index === 0 ? "1rem" : 0,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <p style={{ margin: "0", fontSize: "14px" }}>{description}</p>{" "}
        <Close
          fontSize="small"
          style={{
            cursor: "pointer",
            color: "hsl(0 84.2% 60.2%)",
            marginTop: 3,
          }}
          onClick={handleCloseErrors}
        />
      </div>
      <p
        style={{
          color: "hsl(240 3.8% 46.1%)",
          fontSize: "0.875rem",
          lineHeight: "1.25rem",
          margin: "0",
          marginTop: 10,
        }}
      >
        {followupAction}
      </p>
      <p
        style={{
          color: "hsl(240 3.8% 46.1%)",
          fontSize: "0.875rem",
          lineHeight: "1.25rem",
          margin: "0",
          marginTop: 10,
        }}
      >
        {cleanText(possibleResolutions)}
      </p>
    </div>
  );
};

export default ErrorAlert;
